module.exports = __webpack_public_path__ + "img/sec1_09.f2d2a96a.png";